import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURReelsModel from "../models/BURReelsModel";

export class BURHasRecoverFreeSpinsCondition implements ICondition {
    public check(): boolean {
        return BURReelsModel.pre_trigger_meters_progress !== undefined;
    }
}
